import { Stack, Button, Typography } from '@locus-taxy/encore-mui';
import { FormatListBulleted } from '@locus-taxy/encore-mui/icons';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';

export interface TimelineEmptyStateProps {
  filterInfo?: unknown;
  resetFilters?: () => void;
}
export default function TimelineEmptyState({
  filterInfo,
  resetFilters,
}: TimelineEmptyStateProps) {
  const { t } = useTranslation();
  const hasFilters = Boolean(
    (filterInfo as { conditions?: unknown[] } | undefined)?.conditions?.length
  );
  return (
    <Stack spacing={3} alignItems="center" textAlign="center">
      <Stack direction="column" spacing={1}>
        <Typography variant="h1" color="text.secondary" gutterBottom>
          <FormatListBulleted fontSize="inherit" />
        </Typography>
        {/* @ts-expect-error: Typography variant "body0" is valid in Encore MUI */}
        <Typography variant="body0" color="text.primary" gutterBottom>
          {t('timeline.noEvents')}
        </Typography>
        {hasFilters && (
          <Typography variant="body1" onClick={resetFilters}>
            {t('timeline.noEventsDescription')}
          </Typography>
        )}
      </Stack>
      {hasFilters && (
        <Button variant="outlined" onClick={resetFilters}>
          {t('timeline.reset')}
        </Button>
      )}
    </Stack>
  );
}
